import { render, staticRenderFns } from "./MainNotice.vue?vue&type=template&id=53746e62&scoped=true&"
import script from "./MainNotice.vue?vue&type=script&lang=js&"
export * from "./MainNotice.vue?vue&type=script&lang=js&"
import style0 from "./MainNotice.vue?vue&type=style&index=0&id=53746e62&prod&scoped=true&lang=css&"
import style1 from "./MainNotice.vue?vue&type=style&index=1&id=53746e62&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53746e62",
  null
  
)

export default component.exports